import { ReactNode } from 'react'
import { TFunctionResult } from 'i18next'
import noop from 'lodash/noop'
import styled from 'styled-components'
import { breakpoints, colors, zIndex } from '@/styles'
import CloseButton from '@/components/close-button'
import SparkleSVG from './../sparkle.svg?react'
import { SectionWrapper, Title } from '../elements/modal'

interface ModalTitleProps {
  onClose: () => void
  heading: string | TFunctionResult
  children?: ReactNode
  showIcon?: boolean
}

const StyledSVG = styled(SparkleSVG)`
  margin-right: 12px;
`

const StickySectionWrapper = styled(SectionWrapper)`
  position: sticky;
  top: 0;
  background: ${colors.white};
  z-index: ${zIndex.modal};
  padding: 24px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 16px 24px;
  }
`

const ModalTitle: React.FC<ModalTitleProps> = ({ onClose = noop, heading, showIcon = true }) => {
  const headingText = heading as string

  return (
    <StickySectionWrapper>
      <Title>
        {showIcon && <StyledSVG />}
        {headingText}
      </Title>
      <CloseButton
        onClick={() => {
          onClose()
        }}
      />
    </StickySectionWrapper>
  )
}

export default ModalTitle
